export class LoadLatestSearchRequests {
  static readonly type = '[Mainpage] Load latest search requests';
}

export class LoadTrendingSearchRequests {
  static readonly type = '[Mainpage] Load trending search requests';
}

export class LoadPopularCategories {
  static readonly type = '[Mainpage] Load popular categories';
}

export class LoadPopularSearchRequests {
  static readonly type = '[Mainpage] Load popular search requests';
}
